import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
const VerifiedShifts = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="top-header-sec mb-3">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">
                  Verified Shifts
                  <div className="clear"></div>
                </h4>

                <div class="row mx-0">
                  <div class="shadowclass top_filters orderpayy mt-0 mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="from_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-01"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                          <div class="datePicker pading_lect">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                        <MultiRangeSlider
                          min={0}
                          max={1000}
                          onChange={({ min, max }) =>
                            console.log(`min = ${min}, max = ${max}`)
                          }
                        />
                      </div>

                      <div class="selecters col-lg-5 col-md-6 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col-12 col-lg-5 px-1">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                            >
                              <option value="">Status</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                        <button class="btn btn_btnblue" type="submit">
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-between align-items-center">
                  <div className="col-md-4">
                    <div className="search-box mt-3">
                      <form type="GET">
                        <input
                          type="text"
                          placeholder="Search"
                          name="keyword1"
                        />
                        <input type="submit" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine2"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine2"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine2"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Pending Shifts</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine2"
                >
                  <div className="row mx-0 pendingShiftMs">
                    <div className="container px-0">
                      <div className="shadowclass mt-0">
                        <div className="col-md-4">
                          <div className="search-box mt-0">
                            <form type="GET">
                              <input
                                type="text"
                                placeholder="Search"
                                name="keyword1"
                              />
                              <input type="submit" />
                            </form>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="checklist-table remove-space ingredTable">
                            <thead>
                              <tr>
                                <th width="180">Request Type</th>
                                <th class="avtar-th"></th>
                                <th>
                                  Requestor <br /> <i>Requestee</i>{" "}
                                </th>
                                <th>
                                  Shift Date (Out)
                                  <br /> <i>Shift Date (In)</i>
                                </th>
                                <th>
                                  Start Time (Out)
                                  <br /> <i>Start Time (In)</i>
                                </th>
                                <th>
                                  End Time (Out)
                                  <br /> <i>End Time (In)</i>
                                </th>
                                <th>
                                  Function
                                  <br /> <i>Function</i>
                                </th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <span class="purple_tag">
                                    {" "}
                                    <i class="owner_icon tag_ico"></i> Need
                                    Owner{" "}
                                  </span>
                                </td>
                                <td class="avtar_pic">
                                  <figure class="reqstr">
                                    <img
                                      src="/img/no-image-found.png"
                                      id="preview"
                                      alt=""
                                    />{" "}
                                  </figure>
                                </td>
                                <td>
                                  <b>Johnny</b>
                                  <br />
                                  (Jasone's Shack!)
                                </td>
                                <td>Jul 11, 2022 </td>
                                <td>11:00am</td>
                                <td>01:00pm</td>
                                <td>Service</td>

                                <td class="actions_sec">
                                  <div className="d-flex">
                                    <a
                                      href="/shifts/edit_shift_individual/10310"
                                      class="circle_icon"
                                    >
                                      <i class="iconSprites eye-icon"> </i>
                                    </a>
                                    <a
                                      href="#_"
                                      class="circle_icon red cancel_shift"
                                      val="10310"
                                    >
                                      <i class="iconSprites cancel-icon"> </i>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default VerifiedShifts;
